import React, { createContext, useContext, useState } from 'react'

import { Toast } from '@/components/common/UI/Toast'
import { ToastMessage } from '@/types/api'

interface ToastContextType {
    showToast: (message: ToastMessage) => void
}

const ToastContext = createContext<ToastContextType | undefined>(undefined)

export function ToastProvider({ children }: { children: React.ReactNode }) {
    const [toasts, setToasts] = useState<(ToastMessage & { id: number })[]>([])

    const showToast = (message: ToastMessage) => {
        setToasts([])
        const id = Date.now()

        setToasts([{ ...message, id }])
    }

    const removeToast = (id: number) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id))
    }

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <div className="fixed top-4 right-4 z-50 flex flex-col gap-2">
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        message={toast.message}
                        type={toast.type}
                        onClose={() => removeToast(toast.id)}
                    />
                ))}
            </div>
        </ToastContext.Provider>
    )
}

export function useToast() {
    const context = useContext(ToastContext)

    if (!context) {
        throw new Error('useToast must be used within a ToastProvider')
    }

    return context
}
